import { H1, If, useRelativeTime } from '@fashionnovateam/nova-ui-toolkit';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useGetVendorItem } from '../../../../Lib/Hooks/ItemService';
import StockDetailsSection from './StockDetailsSection';
import CategoryDetailsSection from './CategoryDetailsSection';
import FitDetailsSection from './FitDetailsSection';
import FabricDetailsSection from './FabricDetailsSection';
import ShoeDetailsSection from './ShoeDetailsSection';
import NotesSection from './NotesSection';
import LogisticsSection from './LogisticsSection';

function ItemDetailsReadOnly() {
  const { id: currentUserId, itemId: currentItemId } = useParams<{
    id: string;
    itemId: string;
  }>();

  const { data: targetItem } = useGetVendorItem(currentUserId, currentItemId);
  const { updated_at: updatedAt } = targetItem || {};

  const relativeTime = useRelativeTime(
    updatedAt ? new Date(updatedAt).getTime() : 0,
  );

  const isShoeCategory = useMemo(
    () => !!targetItem?.category?.toLowerCase().includes('shoe'),
    [targetItem?.category],
  );

  return (
    <div className="flex flex-col gap-3 bg-white rounded-lg p-5 mb-4 h-full w-full">
      <div className="flex flex-row items-center gap-3 mb-3">
        <H1 className="text-sm text-base-primary font-medium leading-tight">
          Purchase Order
        </H1>
        <span className="text-xs text-[#1D24338C] ml-auto">{relativeTime}</span>
      </div>
      {/* TODO: Hiding ColorsTable for now, we'll need to add it back only on specific stages later */}
      {/* <ColorsTable item={targetItem} /> */}
      <div className="flex flex-row gap-3 flex-1 h-0">
        <div className="flex flex-col flex-1 gap-3">
          <LogisticsSection item={targetItem} />
          <CategoryDetailsSection item={targetItem} />
          <NotesSection item={targetItem} />
        </div>
        <div className="flex flex-col flex-1 gap-3">
          <StockDetailsSection item={targetItem} />
          <FitDetailsSection item={targetItem} />
          <FabricDetailsSection item={targetItem} />
          <If condition={isShoeCategory}>
            <ShoeDetailsSection item={targetItem} />
          </If>
        </div>
      </div>
    </div>
  );
}

export default ItemDetailsReadOnly;
